module.exports = __webpack_public_path__ + "static/media/2.149d133d.png";